<div class="interaction-bar-wrapper notifications">
  <div class="interaction-bar-title default-cursor">
    Notifications
    <span class="counter">({{ unseenCount }})</span>
  </div>

  <div class="header">
    <div class="header-navigation">
      <div (click)="prevTab()" class="btn-back">
        <span class="icon-arrow-right"></span>
      </div>
      <div class="title default-cursor">
        @if (selectedCategory == NOTIFICATION_CATEGORIES.ALL) {
          <span>All Notifications</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.MESSAGES) {
          <span>Messages</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.SCHEDULE) {
          <span>Schedule</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.PROPOSALS) {
          <span>Proposals</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.INVOICES) {
          <span>Invoices</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.INVITES) {
          <span>Invites</span>
        }
        @if (selectedCategory == NOTIFICATION_CATEGORIES.TEAM) {
          <span>Teams</span>
        }
      </div>
      <div (click)="nextTab()" class="btn-next">
        <span class="icon-arrow-right"></span>
      </div>
    </div>

    <div class="bubble-selection">
      @for (category of notificationCategories; track category) {
        <div (click)="setSelectedCategory(category)" class="notification-bubble">
          <span
            [ngClass]="{
              checked: selectedCategory === category,
              unchecked: selectedCategory !== category,
              'bubble-pink': category === NOTIFICATION_CATEGORIES.SCHEDULE,
              'bubble-yellow': category === NOTIFICATION_CATEGORIES.MESSAGES,
              'bubble-green': category === NOTIFICATION_CATEGORIES.PROPOSALS,
              'bubble-blue': category === NOTIFICATION_CATEGORIES.INVOICES,
              'bubble-dark': category === NOTIFICATION_CATEGORIES.ALL || category === NOTIFICATION_CATEGORIES.INVITES,
              'bubble-team': category === NOTIFICATION_CATEGORIES.TEAM,
            }"
            class="icon-checkbox-round-u"
          ></span>
        </div>
      }
    </div>
    <mat-progress-bar
      [ngClass]="{ 'opacity-0': !isLoading }"
      class="custom-loading-progress-bar"
      mode="indeterminate"
    ></mat-progress-bar>
  </div>

  <div class="interaction-bar-content">
    <ng-scrollbar class="std-scrollbar" appearance="native" visibility="visible" orientation="vertical">
      <div class="mb-4 mr-3">
        @if (notificationCount > 0 && !isLoading && unseenCount !== 0) {
          <div>
            <div (click)="markAllAsRead()" class="mark-all btn-small">Mark all as read</div>
          </div>
        }
        <!-- todo: refactor notifications to include invitations properly-->
        <!-- Temporary solution to show received invitations here -->
        @for (invitation of invitations(); track invitation) {
          <div class="flex justify-between w-full mt-2">
            <div class="flex flex-col">
              <div class="flex gap-1 text-size_xl text-navy-900">
                <span class="font-bold">Project Invite</span>
                <span>{{ invitation.project?.title }}</span>
              </div>

              <div class="flex gap-1 text-size_m text-navy-700">
                <span class="font-semibold">{{ invitation?.user?.name }}</span>
                <span>{{ invitation?.user?.company_name }}</span>
              </div>
            </div>
            <div class="flex gap-1">
              <app-simple-button (click)="acceptInvite(invitation)" size="small" buttonStyle="color_secondary_filled"
                >ACCEPT</app-simple-button
              >
              <app-simple-button (click)="dismissInvite(invitation)" size="small" buttonStyle="color_secondary_border"
                >DISMISS</app-simple-button
              >
            </div>
          </div>
        }

        <!--  present unseen notifications first      -->
        @for (notificationMaps of notificationGroups; track notificationMaps) {
          @for (
            notificationMap of notificationMaps | keyvalue: mapCompareFn;
            track notificationMap;
            let index = $index
          ) {
            <div>
              @if (notificationMap?.value?.length > 0) {
                <div class="date-separator">
                  @if (notificationMap.key === today) {
                    TODAY
                  }
                  @if (notificationMap.key !== today) {
                    @if (isThisYear(notificationMap.key)) {
                      {{ notificationMap.key | datepipe: DMMM }}
                    } @else {
                      {{ notificationMap.key | datepipe: UTC_TO_LOCAL }}
                    }
                  }
                </div>
              }
              @for (notification of notificationMap.value; track notification) {
                <div>
                  <div (click)="openNotification(notification)" class="notification-item">
                    <div class="text-wrapper">
                      <div class="title">
                        {{ notification.title }}
                      </div>
                      <div class="additional-info" [innerHTML]="notification.message"></div>
                      <div class="subtitle-info">
                        {{ notification.subtitle }}
                      </div>
                    </div>
                    @if (!notification.is_seen) {
                      <div class="notification-bubble">
                        <span
                          [ngClass]="{
                            'bubble-pink': notification?.notification_type?.includes(NOTIFICATION_CATEGORIES.SCHEDULE),
                            'bubble-yellow': notification?.notification_type?.includes(
                              NOTIFICATION_CATEGORIES.MESSAGES
                            ),
                            'bubble-green': notification?.notification_type?.includes(
                              NOTIFICATION_CATEGORIES.PROPOSALS
                            ),
                            'bubble-blue': notification?.notification_type?.includes(NOTIFICATION_CATEGORIES.INVOICES),
                            'bubble-dark': notification?.notification_type?.includes(NOTIFICATION_CATEGORIES.INVITES),
                            'bubble-team': notification?.notification_type?.includes(NOTIFICATION_CATEGORIES.TEAM),
                          }"
                          class="icon-checkbox-round-u"
                        ></span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </ng-scrollbar>

    @if (notificationCount === 0 && invitations()?.length === 0 && !isLoading) {
      <div class="default-cursor notification-item">
        <div class="text-wrapper default-cursor no-notifications-wrapper">
          <div class="additional-info no-data default-cursor">No Notifications</div>
        </div>
      </div>
    }
  </div>
</div>
